import esContent from './asaas.es';

export default {
  ...esContent,
};
